export default function Loader() {
    return (
        <div className="loader-container">
            <div className="lds-dual-ring"></div>
        </div>
    )
}